export const GUIDE = 'Guide';
export const CHECK_WEBSITE = 'Check website';
export const GUIDE_TYPE = 'Guide Type';
export const AFFILIATION = 'Affiliation';
export const CANCER_TYPE = 'Cancer type';
export const SELECT_CANCER_TYPE = 'Select Cancer type';
export const GUIDE_SEARCH_PLACEHOLDER = 'Search by guide role, name or category';
